// extracted by mini-css-extract-plugin
export default {"textarea":"Chat_textarea__+sYzl","textareaContainer":"Chat_textareaContainer__krLlr"};